// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"b598edee","182":"13481331","238":"15568e53","417":"7798a1c9","445":"b0660853","453":"79a79848","751":"fba82bd8"}[chunkId] + ".chunk.js";
};